
(function (doc, win) {

  // document.body.addEventListener('copy', function (event) {
  //   if (event.target.parentElement != null && event.target.parentElement.parentElement != null && event.target.parentElement.parentElement.classList.contains('msg')) {
  //     return
  //   }
  //   if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
  //     event.preventDefault();  // 如果不是从 input 复制的，阻止复制动作
  //   }
  // });

  Date.prototype.nextHour = function (hours = 0) {
    const dt = new Date(this);
    const h = Number(hours);
    if (!isNaN(h)) {
      dt.setHours(dt.getHours() + h);
    }
    return dt;
  }

  Date.prototype.nextDate = function (d) {
    var dt = new Date(this);
    dt.setDate(dt.getDate() + parseInt(d));
    return dt;
  }

  Date.prototype.getFullstring = function (type = 1) {
    var m = this.getMonth() + 1;
    var d = this.getDate();
    var res = this.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d);
    // alert('----getFullstring---000-----'+res);
    if (type != undefined && parseInt(type) == 2) {
      var h = this.getHours();
      var mts = this.getMinutes();
      var sec = this.getSeconds();
      res += ' ' + (h < 10 ? '0' : '') + h + ':' + (mts < 10 ? '0' : '') + mts + ':' + (sec < 10 ? '0' : '') + sec;
    }
    //alert('----getFullstring---111-----'+res);
    return res;
  }

  Date.prototype.addHour = function (hours) {
    var dt = new Date(this);
    dt.setHours(dt.getHours() + parseInt(hours));
    return dt;
  }

  Date.prototype.monthCalendarFirstday = function () {
    var dt = new Date(this);
    dt.setDate(1 - dt.getDay());
    return dt;
  }

  Date.prototype.nextWeekDate = function () {
    var dt = new Date(this);
    dt.setDate(this.getDate() + 7);
    return dt;
  }

  Date.prototype.nextMonthDate = function (mth = 1, sDate = 1) {
    var dt = new Date(this);
    mth = mth ? parseInt(mth) : 1;
    if (0 != parseInt(sDate)) {
      dt.setDate('01');
    }
    dt.setMonth(dt.getMonth() + mth);
    return dt;
  }

  Date.prototype.prevMonthDate = function (m = 1, sDate = 1) {
    var dt = new Date(this);
    m = m ? parseInt(m) : 1;
    dt.setMonth(dt.getMonth() - m);
    if (0 != parseInt(sDate)) {
      dt.setDate('01');
    }
    return dt;
  }

  Date.prototype.getWeekName = function () {
    var weekName = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
    return weekName[this.getDay()];
  }

  Date.prototype.monthFullString = function (t = 0) {
    var months = t == 0 ? ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"] :
      ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
    return months[this.getMonth()];
  }

  Date.prototype.monthDiff = function (d) {
    //console.log('('+parseInt(d.getFullYear()) +'-'+ parseInt(this.getFullYear())+') * 12 + '+parseInt(d.getMonth())+'-'+parseInt(curdate.getMonth()) );
    return (parseInt(d.getFullYear()) - parseInt(this.getFullYear())) * 12 + parseInt(d.getMonth()) - parseInt(this.getMonth());
  }

  Date.prototype.dayDiff = function (d) {
    return Math.round((this - new Date(d + 'T00:00:01')) / 8.64e7);
  }

  var docEl = doc.documentElement,
    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
    recalc = function () {
      var clientWidth = docEl.clientWidth;
      if (!clientWidth) return;
      // Pick the scale by the viewport width incl. the scrollbar, like CSS @media and DeviceUtils do.
      // clientWidth leaves the scrollbar out, so a ~751-767px desktop window got the mobile scale with
      // the desktop layout (everything twice as big).
      var viewportWidth = win.innerWidth || clientWidth;
      if (clientWidth > 1640) {
        docEl.style.fontSize = '10px';
      } else if (viewportWidth > 750) {
        docEl.style.fontSize = 10 * (clientWidth / 1640) + 'px';
      } else {
        docEl.style.fontSize = 10 * (clientWidth / 375) + 'px';
      }
    };

  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window);
